<template>
  <MappingMenu />
  <b-row class="pt-1 mb-4">
    <b-col sm="3">
      <SearchInput v-model="searchStr" :searchText="searchStr" @search="search" @clearSearch="clearSearch" />
    </b-col>
  </b-row>
  <b-row>
    <b-col class="mb-5">
      <transition name="fade" mode="out-in">
        <div v-if="loading" class="d-flex justify-content-center mt-4 mb-4">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem" />
        </div>
        <div v-else>
          <b-table responsive hover :fields="fields" :items="countries">
            <template #cell(is_virtual)="data">
              <span>{{ data.item.is_virtual ? '✔️' : '—' }}</span>
            </template>
            <template #cell(dismissed)="data">
              <span>{{ data.item.dismissed ? '✔️' : '—' }}</span>
            </template>
            <template #cell(edit)="data">
              <div class="text-center">
                <button @click="showUpdateModal(data)" class="editCountryBtn">
                  <BIconPencilSquare width="24px" height="24px" />
                </button>
              </div>
            </template>
          </b-table>
          <Paginator
            @next="showNextPage"
            @prev="showPrevPage"
            @selectPage="selectPage"
            :pagesCount="this.pagesCount"
            :currentPage="this.currentPage"
            :limit="this.limit"
            :itemsCount="this.itemsCount"
            class="pagination mt-4 mb-4"
          />
        </div>
      </transition>
    </b-col>
  </b-row>
  <CountryModal
    :showModal="showModal"
    :countryData="countryData"
    @countrySaved="handleCountrySaved"
    @hideModal="hideModal"
  />
</template>

<script>
import { useActAdminApi } from '@/use/actAdminApi'
import MappingMenu from '@/components/Mapping/Menu'
import SearchInput from '@/components/Mapping/Common/SearchInput'
import CountryModal from '@/components/Mapping/Countries/CountryModal'
import Paginator from '@/components/Paginator.vue'
import { BIconPencilSquare } from 'bootstrap-icons-vue'

export default {
  components: { MappingMenu, SearchInput, CountryModal, Paginator, BIconPencilSquare },
  emits: ['toggleModal'],
  data: () => {
    return {
      loading: true,
      showModal: false,
      countryData: {},
      countries: [],
      fields: ['id', 'iso', 'name', 'alt_name', 'icon_filename', 'is_virtual', 'dismissed', { key: 'edit', label: '' }],
      searchStr: '',
      currentPage: 1,
      limit: 100,
      pagesCount: 1,
      itemsCount: null
    }
  },
  setup() {
    const { initApiInst, actMappingApi } = useActAdminApi()
    return { initApiInst, actMappingApi }
  },
  mounted() {
    this.getCountries()
  },
  methods: {
    async getCountries() {
      this.loading = true
      this.searchStr = this.$route.query.search_str ?? ''
      const page = Number(this.$route.query.page ?? 1)
      try {
        await this.initApiInst()
        const resp = await this.actMappingApi.getCountries({ searchStr: this.searchStr, page })
        if (resp && resp.countries) {
          this.countries = resp.countries
          this.currentPage = resp.page
          this.limit = resp.limit
          this.pagesCount = resp.pages
          this.itemsCount = resp.total
        }
      } catch (e) {
        this.countries = []
      } finally {
        this.loading = false
      }
    },
    async search() {
      if (this.searchStr) {
        this.currentPage = 1
        await this.$router.push({ query: { page: this.currentPage, search_str: this.searchStr } })
        await this.getCountries()
      }
    },
    async clearSearch() {
      this.searchStr = ''
      await this.$router.push({ query: null })
      await this.getCountries()
    },
    async getByPage(page) {
      await this.$router.push({ query: { ...this.$route.query, page } })
      this.getCountries()
    },
    async showNextPage() {
      await this.getByPage(this.currentPage + 1)
    },
    async showPrevPage() {
      await this.getByPage(this.currentPage - 1)
    },
    async selectPage(page) {
      await this.getByPage(page)
    },
    showUpdateModal(editData) {
      this.countryData = editData.item
      this.showModal = true
    },
    hideModal() {
      this.showModal = false
      this.countryData = {}
    },
    async handleCountrySaved() {
      this.hideModal()
      localStorage.removeItem('countriesIdsNames')
      localStorage.removeItem('dismissedCountriesIds')
      await this.getCountries()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/animations/fade-data.scss';

.editCountryBtn {
  border: none;
  background: transparent;
  padding: 0;
}
</style>
